export default {"src":"/_next/static/media/AdTechIcon.975826b0.svg","height":70,"width":130};